import { useSelector } from "react-redux";
import TruInkSelectedSiteHeader from "./TruInkSelectedSiteHeader";
import { Divider } from "@mui/material";
import TruinkSiteOptions from "./TruinkSiteOptions";
import TruinkAddImportButtons from "./TruinkAddImportButtons";
import TrunInkDataTable from "./TrunInkDataTable";
import PluginsPanel from "./PluginsPanel";
import { useState } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

function TruInkSelectedSiteUi() {
  const selectedSite = useSelector((state) => state.truInk.selectedSite);
  const selectedSiteOption = useSelector((state) => state.truInk.selectedSiteOption);
  const [refreshKey, setRefreshKey] = useState(0);
  const handleRefresh = () => {
    setRefreshKey((prev) => prev + 1);
  };
  const [templateSearchValue, setTemplateSearchValues] = useState("")
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        height: "100%",
        padding: {
          xs:"0% 5%",
          md:"0% 4%"
        }
          ,
        overflowY: "auto",
        scrollbarWidth: "none",
      }}
    >
      <TruInkSelectedSiteHeader selectedSite={selectedSite} />
      <div
        style={{
          marginTop: "3vh",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "start",
          justifyContent: "flex-start",
        }}
      >
        <Divider orientation="horizontal" style={{ width: "100%" }} />
        <TruinkSiteOptions />
        <Divider orientation="horizontal" style={{ width: "100%" }} />
      </div>
      <Box
        sx={{
          marginTop: {
            xs:"1vh",
            sm:"3vh",
            md:"5vh"
          },
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "2vw",
        }}
      >
        <TruinkAddImportButtons
          templateSearchValue={templateSearchValue}
          setTemplateSearchValues={setTemplateSearchValues}
          onSaveSuccess={handleRefresh}
        />
        {selectedSiteOption === "Plugins" ? (
          <PluginsPanel />
        ) : (
          <TrunInkDataTable
            templateSearchValue={templateSearchValue}
            setTemplateSearchValues={setTemplateSearchValues}
            refreshKey={refreshKey}
            onSaveSuccess={handleRefresh}
          />
        )}
      </Box>
    </Box>
  );
}

export default TruInkSelectedSiteUi;
